<template>
    <CustomDialog v-model="visible" :defaultTitle="$t('staff_planning_v3.copy_modal.title')">
        <template #content>
            <div class="ppv2-space-y-6">
                <!-- Source Staff (only when showSourceSelection is true) -->
                <div v-if="showSourceSelection">
                    <label class="ppv2-block ppv2-text-sm poppinsSemiBold ppv2-text-gray-700 ppv2-mb-2">
                        {{ $t('staff_planning_v3.copy_modal.source_employee') }}
                    </label>
                    <BaseSelect
                        v-model="copyForm.sourceStaff"
                        :options="staffResouerceList"
                        :placeholder="$t('staff_planning_v3.copy_modal.select_employee')"
                        fixed-dropdown
                    />
                </div>
                <!-- Target Staff -->
                <div>
                    <label class="ppv2-block ppv2-text-sm poppinsSemiBold ppv2-text-gray-700 ppv2-mb-2">
                        {{ $t('staff_planning_v3.copy_modal.target_employee') }}
                    </label>
                    <BaseSelect
                        v-model="copyForm.targetStaff"
                        :options="staffResouerceList"
                        :placeholder="$t('staff_planning_v3.copy_modal.select_employee')"
                        fixed-dropdown
                    />
                </div>
                <div>
                    <label class="ppv2-block ppv2-text-sm poppinsSemiBold ppv2-text-gray-700 ppv2-mb-2">
                        {{ $t('staff_planning_v3.copy_modal.weeks_to_copy') }}
                    </label>

                    <BaseSelect
                        v-model="copyForm.targetWeeks"
                        :options="copyWeekOptions"
                        option-label="label"
                        option-value="value"
                        :searchable="true"
                        :multiple="true"
                        :placeholder="$t('staff_planning_v3.copy_modal.select_week')"
                        fixed-dropdown
                    />
                </div>
            </div>
        </template>

        <template #actions>
            <ModalActions
                @cancel="closeModal"
                @confirm="validateCopy"
                :confirmLabel="$t('staff_planning_v3.copy_modal.validate')"
            />
        </template>
    </CustomDialog>
</template>

<script>
import CustomDialog from '../../../Shared/CustomDialog.vue'
import WeekSelector from './WeekSelector.vue'
import BaseSelect from '../../../Shared/BaseSelect.vue'
import ModalActions from './ModalActions.vue'

export default {
    components: {
        CustomDialog,
        WeekSelector,
        BaseSelect,
        ModalActions,
    },
    props: {
        value: Boolean,
        availableWeeks: {
            type: Array,
            default: () => [],
        },
        initialStaffId: {
            type: [String, Number],
            default: null,
        },
        selectedWeek: {
            type: String,
            default: '',
        },
        showSourceSelection: {
            type: Boolean,
            default: false,
        },
        staffResouerceList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            copyForm: {
                sourceStaff: null,
                targetStaff: null,
                targetWeeks: [],
            },
        }
    },
    watch: {
        value(val) {
            if (val) {
                this.copyForm.targetStaff = this.initialStaffId
                this.copyForm.targetWeeks = []
            }
        },
    },
    computed: {
        visible: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
        copyWeekOptions() {
            const options = []

            const [currentYear, currentWeekStr] = this.selectedWeek.split('-W')

            let year = parseInt(currentYear)

            // Add all weeks from week 1 to week 52 for the current year
            for (let week = 1; week <= 52; week++) {
                options.push({
                    value: `${year}-W${String(week).padStart(2, '0')}`,
                    label: `${this.$t('staff_planning_v3.components.create_shift.week')} ${week}`,
                })
            }

            return options
        },
    },
    methods: {
        closeModal() {
            this.visible = false
        },
        validateCopy() {
            if (this.showSourceSelection && !this.copyForm.sourceStaff) {
                this.$toast.error(this.$t('staff_planning_v3.copy_modal.error_source'))
                return
            }
            if (!this.copyForm.targetStaff) {
                this.$toast.error(this.$t('staff_planning_v3.copy_modal.error_target'))
                return
            }
            if (!this.copyForm.targetWeeks || this.copyForm.targetWeeks.length === 0) {
                this.$toast.error(this.$t('staff_planning_v3.copy_modal.error_weeks'))
                return
            }
            this.$emit('confirm', {
                sourceStaffId: this.showSourceSelection ? this.copyForm.sourceStaff : null,
                targetStaffId: this.copyForm.targetStaff,
                targetWeeks: this.copyForm.targetWeeks,
            })
        },
    },
}
</script>
